import React, { useEffect, useState } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import { CONTENT_ID, CONTENT_TYPE, DASHBOARD, HOME } from 'constants/routesConstants'
import { SearchBar } from 'components/organisms'
import { ContentType, Dashboard, Home, Single } from 'components/pages'
import { MainWrapper } from 'components/atoms'
import { useScreenZone } from 'hooks/useScreens'
import { getSearch } from 'services/content-service'

const Root = () => {
  const location = useLocation()
  const [searchQuery, setSearchQuery] = useState('')
  const [searchArray, setSearchArray] = useState([])
  const [isSearchMode, setIsSearchMode] = useState(false)
  const locationArray = location.pathname.split('/').filter(item => item)
  const [contentType, contentId] = locationArray
  const locationObject = { contentType, contentId }
  const zone = useScreenZone(JSON.parse(localStorage.getItem('screenApp'))?.value)

  useEffect(() => {
    if (zone) {
      getSearch(zone, searchQuery)
        .then(results => setSearchArray(results.data))
        .catch(() => {
          setSearchArray([])
        })
    }
  }, [searchQuery])

  const handleSearch = data => {
    setSearchQuery(data)
  }

  const handleStatus = isSearch => {
    setIsSearchMode(isSearch)
  }

  return (
    <>
      {location.pathname !== HOME && (
        <SearchBar
          location={locationObject}
          handleSearch={handleSearch}
          handleStatus={handleStatus}
          isSearchMode={isSearchMode}
        />
      )}
      <MainWrapper>
        <Routes>
          <Route path={HOME} element={<Home />} />
          <Route
            path={DASHBOARD}
            element={
              zone && (
                <Dashboard
                  zone={zone}
                  search={searchArray}
                  searchQuery={searchQuery}
                  searchMode={isSearchMode}
                  handleStatus={handleStatus}
                />
              )
            }
          />
          <Route
            path={CONTENT_TYPE}
            element={
              zone &&
              contentType && (
                <ContentType
                  zone={zone}
                  search={searchArray}
                  searchQuery={searchQuery}
                  searchMode={isSearchMode}
                  handleStatus={handleStatus}
                  contentType={contentType}
                />
              )
            }
          />
          <Route
            path={CONTENT_ID}
            element={
              zone && (
                <Single
                  zone={zone}
                  search={searchArray}
                  searchQuery={searchQuery}
                  searchMode={isSearchMode}
                  handleStatus={handleStatus}
                />
              )
            }
          />
        </Routes>
      </MainWrapper>
    </>
  )
}

export default Root
